import { Injectable, Output, EventEmitter } from "@angular/core";
import { Observable, Subscription } from "rxjs/Rx";
import { PruHttpService } from "./pru-http.service";
import { AggregationService } from './aggregation.service';
import { SessionStorageService } from './web-storage/session-storage.service';
import { hooks } from "../models/initapp/hooks";

//declare var environment: any;
@Injectable({
  providedIn: "root"
})
export class LinkService {
  public linkBanner: boolean = false;
  public hasGoals: boolean = true;
  public linkBannerContent$: any = null;
  temp: hooks;
  goalsCheck: boolean = false;
  hideBanner: boolean = true;
  private subscription: Subscription;
  //showEngageB: boolean;
  @Output() linkEvent: EventEmitter<any> = new EventEmitter();
  constructor(
    private _pruHttpService: PruHttpService,
    private _aggregationService: AggregationService,
    private _sessionStorageService: SessionStorageService,
  ) {
    //   this.showEngageB = false;
  }

  getLinkGoals(): Observable<any> {
    let url = "/api/co/secure/planning/v1/goals";
    return this._pruHttpService.get(url, "LinkService");
  }
  
  triggerGoalsCheck(): void {
    this.subscription = this._aggregationService.aggregationDone.subscribe((res: any) => {
      if (res && res === 'aggregationDone') {
        this.subscription.unsubscribe();
        let goals = this._sessionStorageService.getItem('userLinkGoals', true);
        
        if (goals) {
          this.checkForGoals(goals);
        } else {
          this.getLinkGoals().subscribe((res: any) => {
            this._sessionStorageService.setItem('userLinkGoals', res, true);
            this.checkForGoals(res);
          },
          (err) => {
            this.linkEvent.emit('noGoals');
            this.hasGoals = false;
            console.log("goals service Failure:", err);
          })
        }
      }
    });
  }

  checkForGoals(userGoals): void {
    this.goalsCheck = true;
    this.hideBanner = false;

    if (userGoals.length > 0) {
      this.hasGoals = true;
      this.linkEvent.emit('hasGoals');
    } else {
      this.hasGoals = false;
      this.linkEvent.emit('noGoals');
    }
  }


  // checkPermissions(): Observable<any> {
  //   let url = "/onprem/api/co/secure/ucdservices/v1/permissions";
  //   return this._pruHttpService.get(url, "checkPermissions");
  // }

  // getMflLinkContent(): Observable<any> {
  //   let domain = environment.PUBLIC_RENDER_DOMAIN;
  //   let domainLink = /qa/i.test(domain)
  //     ? "/wps/wcm/connect/IS_Content_Prudential_QATest_EN/SA-MFL/SA-Common/SA-MFLSPA-Recommended/SA-CTAData/CT-LinkCTA-Not-Started?presentationtemplate=IS_Foundational_Design/PT-MA-CTA-NotStartedv2&subtype=json"
  //     : "/wps/wcm/connect/IS_Content_Prudential_EN/SA-MFL/SA-Common/SA-MFLSPA-Recommended/SA-LinkCTA/CT-LinkCTA-Not-Started?presentationtemplate=IS_Foundational_Design/PT-MA-CTA-NotStartedv2&subtype=json";
  //   let url = domain + domainLink;
  //   return this._pruHttpService.getWcmContent(url);
  // }

  // getHTMLText(serviceURL: string): Observable<String> {
  //   //  return this._pruHttpService.getText(serviceURL, "LinkBannaer");

  //   if (!this.linkBannerContent$) {
  //     this.linkBannerContent$ = this._pruHttpService
  //       .getText(serviceURL, "LinkBannaer")
  //       .pipe(shareReplay());
  //   }
  //   return this.linkBannerContent$;
  // }
}
